var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenDash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843 4625 c-175 -48 -317 -195 -353 -368 -7 -35 -10 -226 -8 -584 3 -519 3 -532 24 -559 39 -53 71 -69 134 -69 63 0 95 16 134 69 20 27 21 42 26 566 5 524 6 539 26 566 11 15 33 37 48 48 27 20 42 21 566 26 524 5 539 6 566 26 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 21 -39 21 -569 23 -442 2 -552 -1 -594 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3135 4626 c-118 -51 -124 -224 -11 -289 15 -9 160 -13 558 -17 522 -5 537 -6 564 -26 15 -11 37 -33 48 -48 20 -27 21 -42 26 -566 5 -524 6 -539 26 -566 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 40 24 559 2 358 -1 549 -8 584 -37 175 -179 322 -357 368 -80 21 -1091 22 -1138 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 2066 c-37 -17 -70 -52 -84 -89 -7 -19 -11 -205 -11 -551 0 -566 1 -580 56 -688 59 -116 196 -220 327 -248 35 -7 226 -10 584 -8 519 3 532 3 559 24 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 20 -42 21 -566 26 -524 5 -539 6 -566 26 -15 11 -37 33 -48 48 -20 27 -21 42 -26 566 -5 524 -6 539 -26 566 -11 15 -32 37 -46 47 -34 25 -113 32 -153 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4420 2069 c-29 -12 -67 -46 -83 -74 -9 -14 -13 -177 -17 -557 -5 -522 -6 -537 -26 -564 -11 -15 -33 -37 -48 -48 -27 -20 -42 -21 -566 -26 -524 -5 -539 -6 -566 -26 -53 -39 -69 -71 -69 -134 0 -63 16 -95 69 -134 27 -21 40 -21 559 -24 358 -2 549 1 584 8 179 38 336 195 373 375 7 33 10 236 8 582 -3 519 -3 532 -24 559 -11 15 -32 37 -46 47 -31 23 -111 32 -148 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenDash);
export default __webpack_public_path__ + "static/media/fullscreen-dash.bc52b11374dfb89c17d70b227b0c5e86.svg";
export { ForwardRef as ReactComponent };